<template>
  <div :class="['email-image-section', showImages ? 'slide-open' : 'slide-close']">
    <div class="image-upload-section">
      <upload-attachment
          label="email_image"
          :ownerId="campaignId"
          ownerType="Campaign"
          shouldReload
          showInputFile
          :uploadConfig="uploadConfig"
          @configureAttachment="configureAttachmentResponse"
          @reloadAttachments="loadImages">
      </upload-attachment>

      <div class="image-copy-paste-section">
        <div>or</div>
        <input type="text"
               class="image-paste-input"
               name="image_url"
               placeholder="paste image url"
               v-model="copiedUrl"
               @blur="$emit('insertImage', copiedUrl)" />
      </div>
    </div>

    <div v-if="errorMessage" class="error-label">{{errorMessage}}</div>

    <div v-if="campaignImages" class="uploaded-campaign-email-images">
      <small class="uploaded-images">Uploaded Images:</small>
      <div class="email-image-preview"
           v-for="image in campaignImages"
           :key="image.id">
        <image-preview
            deleteClasses="delete-email-image"
            deleteText="&times;"
            :src="image.thumb"
            :uuid="image.uuid"
            @reload="loadImages">
        </image-preview>
        <span :id="`insert-${image.id}`" @click="$emit('insertImage', image.url)">insert again</span>
      </div>
    </div>

  </div>
</template>

<script>
  import axiosConfig from '../../../packs/axios'
  import ImagePreview from '../shared/ImagePreview'
  import { isObject } from '../../utilities'
  import UploadAttachment from '../FormItems/UploadAttachment'

  export default {
    props: {
      campaignId: String,
      dragIcon: [Element, Object],
      imageToResize: Element,
      showImages: Boolean,
    },

    name: 'InsertImages',

    components: {
      ImagePreview,
      UploadAttachment,
    },

    data() {
      return {
        campaignImages: null,
        copiedUrl: null,
        errorMessage: null,
        resizeDimensions: {},
        uploadConfig: {
          displayType: 'image-upload-input',
          differentLabel: 'upload image',
        }
      };
    },

    methods: {
      configureAttachmentResponse(responseData) {
        this.$emit('insertImage', responseData.url)
      },

      loadImages() {
        const url = `/api/v3/campaigns/${this.campaignId}/campaign_attachments?label=email_image`
        axiosConfig.get(url)
          .then((response) => {
            const data = response.data
            if (isObject(data)) {
              this.campaignImages = data.length > 0 ? response.data : null
              this.errorMessage = null
            } else {
              this.errorMessage = 'no images loaded'
            }
          })
          .catch((error) => { this.errorMessage = `issue loading images ${error}` })
      },

      addOverlay() {
        const parent = this.dragIcon.parentNode,
          view = this
        parent.classList.add('resizable')
        this.dragIcon.addEventListener('mousedown', view.initDragging)
      },

      initDragging(event) {
        event.preventDefault()
        const view = this
        this.resizeDimensions.initDraggingX = event.pageX
        this.resizeDimensions.initDraggingY = event.pageY
        document.addEventListener('mouseup', view.stoppedDragging)
        document.addEventListener('mousemove', view.onImageDrag)
      },

      onImageDrag(event) {
        const image = this.imageToResize,
          minSize = 20,
          originalWidth = parseFloat(getComputedStyle(image, null).getPropertyValue('width').replace('px', '')),
          originalHeight = parseFloat(getComputedStyle(image, null).getPropertyValue('height').replace('px', '')),
          height = originalHeight + (event.pageY - this.resizeDimensions.initDraggingY),
          width = originalWidth + (event.pageX - this.resizeDimensions.initDraggingX)

        if (width > minSize && width < this.resizeDimensions.maxWidth) {
          this.$emit('setResizeDimension', 'width', width + 'px')
        }
        if (height > minSize && height < this.resizeDimensions.maxHeight) {
          this.$emit('setResizeDimension', 'height', height + 'px')
        }
      },

      resetResize() {
        const view = this
        this.resizeDimensions = {}
        document.removeEventListener('mouseup', view.stoppedDragging)
      },

      setImageDimensions() {
        this.resizeDimensions.maxHeight = this.imageToResize.height
        this.resizeDimensions.maxWidth = this.imageToResize.width
      },

      stoppedDragging() {
        const view = this
        document.removeEventListener('mousemove', view.onImageDrag)
        this.$emit('contentUpdate')
      },
    },

    created() {
      this.loadImages()
    },

    watch: {
      dragIcon: function () {
        this.dragIcon && this.addOverlay()
      },

      imageToResize: function () {
        if (this.imageToResize) {
          this.setImageDimensions()
        } else {
          this.resetResize()
        }
      },
    }
  }
</script>